import Resource from './basic.js';
import _ from 'lodash';

class User extends Resource {
    constructor(options) {
        const opts = _.defaults({}, options, {
            baseUrl: '/mtm-gateway-api/v1/users',
            idField: 'user_name'
        });

        super(opts);

        this._new = true;
    }

    isNew() {
        return this._new;
    }

    url() {
        if (this.isNew()) {
            return this.baseUrl;
        } else {
            return this.baseUrl + '/' + encodeURIComponent(this.get('user_name'));
        }
    }

    fetch(id) {
        return super.fetch(id)
        .then(() => {
            this._new = false;
        });
    }
}

export default User;
